"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genCreateClusterCkbVirtualTx = void 0;
const core_1 = require("@spore-sdk/core");
const utils_1 = require("../utils");
const rgbpp_1 = require("../utils/rgbpp");
const constants_1 = require("../constants");
const spore_1 = require("../utils/spore");
const error_1 = require("../error");
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
/**
 * Generate the virtual ckb transaction for creating cluster
 * @param collector The collector that collects CKB live cells and transactions
 * @param rgbppLockArgs The rgbpp assets cell lock script args whose data structure is: out_index | bitcoin_tx_id
 * @param clusterData The cluster's data, including name and description.
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet(see btcTestnetType for details about BTC Testnet)
 * @param witnessLockPlaceholderSize(Optional) The WitnessArgs.lock placeholder bytes array size and the default value is 5000
 * @param ckbFeeRate(Optional) The CKB transaction fee rate, default value is 1100
 * @param btcTestnetType(Optional) The Bitcoin Testnet type including Testnet3 and Signet, default value is Testnet3
 */
const genCreateClusterCkbVirtualTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ collector, rgbppLockArgs, clusterData, isMainnet, witnessLockPlaceholderSize, ckbFeeRate, btcTestnetType, }) {
    const rgbppLock = (0, rgbpp_1.genRgbppLockScript)(rgbppLockArgs, isMainnet, btcTestnetType);
    const rgbppCells = yield collector.getCells({ lock: rgbppLock });
    if (!rgbppCells || rgbppCells.length === 0) {
        throw new error_1.NoRgbppLiveCellError('No rgbpp cells found with the rgbpp lock args');
    }
    const rgbppCell = rgbppCells[0];
    const inputs = [
        {
            previousOutput: rgbppCell.outPoint,
            since: '0x0',
        },
    ];
    const clusterId = (0, spore_1.generateClusterId)(inputs[0], 0);
    const outputs = [
        Object.assign(Object.assign({}, rgbppCell.output), { 
            // The BTC transaction Vouts[0] for OP_RETURN, Vouts[1] for cluster
            lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(1), isMainnet, btcTestnetType), type: Object.assign(Object.assign({}, (0, constants_1.getClusterTypeScript)(isMainnet)), { args: clusterId }) }),
    ];
    const outputsData = [(0, ckb_sdk_utils_1.bytesToHex)((0, core_1.packRawClusterData)(clusterData))];
    const cellDeps = [
        ...(yield (0, utils_1.fetchTypeIdCellDeps)(isMainnet, { rgbpp: true }, btcTestnetType)),
        (0, constants_1.getClusterTypeDep)(isMainnet),
    ];
    const sporeCoBuild = (0, spore_1.generateClusterCreateCoBuild)(outputs[0], outputsData[0]);
    const witnesses = [constants_1.RGBPP_WITNESS_PLACEHOLDER, sporeCoBuild];
    const ckbRawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    let changeCapacity = BigInt(rgbppCell.output.capacity);
    const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(ckbRawTx) + (witnessLockPlaceholderSize !== null && witnessLockPlaceholderSize !== void 0 ? witnessLockPlaceholderSize : constants_1.RGBPP_TX_WITNESS_MAX_SIZE);
    const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize, ckbFeeRate);
    changeCapacity -= estimatedTxFee;
    ckbRawTx.outputs[ckbRawTx.outputs.length - 1].capacity = (0, utils_1.append0x)(changeCapacity.toString(16));
    const virtualTx = Object.assign({}, ckbRawTx);
    const commitment = (0, rgbpp_1.calculateCommitment)(virtualTx);
    return {
        ckbRawTx,
        commitment,
        clusterId,
        needPaymasterCell: false,
    };
});
exports.genCreateClusterCkbVirtualTx = genCreateClusterCkbVirtualTx;
